import React from 'react';
import Loading from '../../../components/Loading/Loading.jsx';
import getFileData, { fetchPublicDataFile } from '../../../APICall/Api.jsx';
import AlertDialogSlide from '../../../components/TransitionModal/TransitionModalNoButton.jsx';

const isImageIcon = (icon) =>
  !!icon && (/^https?:\/\//i.test(icon) || icon.indexOf('/') !== -1 || /\.(svg|png|jpe?g|webp|gif)$/i.test(icon));

const normalizeImageUrl = (url) => {
  const clean = (url || '').trim();
  if (!clean) return '';
  if (/^https?:\/\//i.test(clean) || clean.indexOf('//') === 0) {
    return encodeURI(clean);
  }
  return encodeURI(`https://buildgreenalbania.org/${clean.replace(/^\/+/, '')}`);
};

const normalizeIconClass = (icon) => {
  const clean = (icon || '').trim();
  if (!clean) return 'fas fa-leaf';
  return /\bfa[bsrl]?\b/.test(clean) ? clean : `fas fa-${clean}`;
};

const getServiceType = (item) => {
  const title = `${item.title || ''} ${item.service || ''}`.toLowerCase();

  if (title.indexOf('grant') !== -1 || title.indexOf('project') !== -1 || title.indexOf('grante') !== -1 || title.indexOf('projekt') !== -1) {
    return 'grant';
  }
  if (title.indexOf('research') !== -1 || title.indexOf('hulum') !== -1 || title.indexOf('kerk') !== -1 || title.indexOf('kërk') !== -1) {
    return 'research';
  }
  if (title.indexOf('consult') !== -1 || title.indexOf('konsul') !== -1) {
    return 'consulting';
  }
  if (title.indexOf('training') !== -1 || title.indexOf('workshop') !== -1 || title.indexOf('event') !== -1 || title.indexOf('traj') !== -1) {
    return 'training';
  }

  return 'default';
};

const getServiceIconClass = (item) => {
  const type = getServiceType(item);

  if (type === 'grant') {
    return 'fas fa-file-signature';
  }
  if (type === 'research') {
    return 'fas fa-microscope';
  }
  if (type === 'consulting') {
    return 'fas fa-handshake';
  }
  if (type === 'training') {
    return 'fas fa-chalkboard-teacher';
  }

  return item.icon && !isImageIcon(item.icon) ? normalizeIconClass(item.icon) : 'fas fa-leaf';
};

class SectionServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
    };
  }

  callAPI = (lang) => {
    fetchPublicDataFile(`Services${lang.capitalize()}.json`)
      .then(
        (result) => this.setState({ isLoaded: true, items: result.services }),
        (error)  => this.setState({ isLoaded: true, error }),
      );
  };

  componentDidMount()              { this.callAPI(this.props.lang); }
  componentWillReceiveProps(next)  {
    if (next.lang !== this.props.lang) {
      this.setState({ isLoaded: false });
      this.callAPI(next.lang);
    }
  }

  render() {
    if (this.state.error)    return <div>Error loading services.</div>;
    if (!this.state.isLoaded) return <Loading />;

    return (
      <section className="bgg-section bgg-section-white">
        <div className="bgg-container">
          {/* Section header */}
          <div className="bgg-section-header">
            {this.props.services && (
              <span className="bgg-section-label">{this.props.services}</span>
            )}
            <div>
              <h2 className="bgg-section-title">{this.props.servicesExpr}</h2>
            </div>
          </div>

          {/* Cards grid */}
          <div className="bgg-services-grid">
            {this.state.items.map((item, key) => (
              <div className="bgg-service-card" key={key}>
                <div className={`bgg-service-icon-wrap bgg-service-icon-${getServiceType(item)}`}>
                  {isImageIcon(item.icon) ? (
                    <React.Fragment>
                      <img
                        src={normalizeImageUrl(item.icon)}
                        alt={item.title}
                        loading="lazy"
                        decoding="async"
                        onError={(event) => {
                          event.currentTarget.style.display = 'none';
                          if (event.currentTarget.nextSibling) {
                            event.currentTarget.nextSibling.style.display = 'block';
                          }
                        }}
                      />
                      <i className={`${getServiceIconClass(item)} bgg-service-fallback-icon`} />
                    </React.Fragment>
                  ) : (
                    <i className={getServiceIconClass(item)} />
                  )}
                </div>

                {/* Labels */}
                {item.service && (
                  <div className="bgg-service-label">{item.service}</div>
                )}
                <div className="bgg-service-title">{item.title}</div>
                <p className="bgg-service-desc">
                  {item.description
                    ? item.description.substring(0, 150) + '…'
                    : ''}
                </p>

                {/* Opens the full service details dialog. */}
                <AlertDialogSlide
                  title={item.title}
                  description={item.description || ''}
                >
                  <button className="bgg-link-btn">
                    {this.props.servicesButton || 'Learn More'}
                    <span aria-hidden="true">&rarr;</span>
                  </button>
                </AlertDialogSlide>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default SectionServices;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionServices.jsx